import React from 'react';
import { connect } from 'dva';
import { Row, Col } from 'antd';

import BaseComponent from '../../../components/BaseComponent';
//import Dimio, {DimioNotice} from '../../../components/Dimio';
import { CardItem, Price } from '../../../components/DimioLibrary';
//import DimioModal from '../../../components/DimioModal';

import { isMobile } from 'react-device-detect';
import config from '../config/config';

/**
 * type: loader - loading item by NOI
 */
class SearchResult extends BaseComponent {
  /*
    constructor(props) {
      super(props);
    }
    componentWillMount() {
    }
  */
  render() {
    const { travel } = this.props;
    const { items } = travel;

    const Item = ({ item }) => {
      return (
        <CardItem
          //        overlayImageRightTop={item.get('city_key')}
          title={item.get('name')}
          thumb={item.get('thumb')}
          url={item.get('url')}>
          <Price currency='AUD'>{item.get('lowest')}</Price>

          {/* item.get('prices') &&
        <Row>
          {item.get('prices').map(price => (
            <Col xs={8}>
              <h3>{() => console.info(price)}</h3>
            </Col>
          ))
          }
        </Row>
        */}
        </CardItem>
      )
    };

    return (
      <section className='travel-sale-list'>
        {items &&
          <Row gutter={5}>
            {items.map((item, idx) => (
              <Col key={idx} xs={12} sm={8}>
                <Item item={item} />
              </Col>
            ))}
          </Row>
        }
      </section>
    );
  }
}


export default connect(({ travel }) => ({
  travel
}))(SearchResult);



// WEBPACK FOOTER //
// ./src/pages/travel/components/SearchResult.js